import Subjects from "../models/subjects";
import { HttpUtils } from "./http-utils";

export class StudentService {

    httpUtils: HttpUtils;
    webApiUrl: string;
    subject: Subjects;

    constructor(subject: Subjects) {
        this.subject = subject;
        this.httpUtils = new HttpUtils();
        this.webApiUrl = `/darshana/api/students`;
    }

    loadList = async (urlParams: URLSearchParams, successHandler: ((data: any) => any)) => {

        const options = {
            method: "GET"
        }

        const request = new Request(`${this.webApiUrl}?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    createStudent(newStudentName: string, successHandler: (data: any) => any) {

        const options = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: newStudentName })
        }

        const request = new Request(this.webApiUrl, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }

    loadTicketStatistic(id: number, successHandler: (data: any) => void) {

        const options = {
            method: "GET"
        }

        var params = { subject: this.subject };
        const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

        const request = new Request(`${this.webApiUrl}/${id}/statistic?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }

    loadShortList(successHandler: (data: any) => void) {

        const options = {
            method: "GET"
        }

        const request = new Request(`${this.webApiUrl}/short`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }

    loadCurrentTicket(studentId: string, subject: Subjects, successHandler: (data: any) => void) {

        const options = {
            method: "GET"
        }

        var params = { subject: this.subject };
        const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

        const request = new Request(`${this.webApiUrl}/${studentId}/tickets/current?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }

    loadTicketById(studentId: string, ticketId: string, subject: Subjects, successHandler: (data: any) => void) {

        const options = {
            method: "GET"
        }

        var params = { subject: this.subject };
        const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

        const request = new Request(`${this.webApiUrl}/${studentId}/tickets/${ticketId}?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }


    loadTickets(id: number, successHandler: (data: any) => void) {

        const options = {
            method: "GET"
        }

        var params = { subject: this.subject };
        const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

        const request = new Request(`${this.webApiUrl}/${id}/tickets?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }

    unassignTicket(completedTicketId: number, successHandler: (_: any) => any) {

        const options = {
            method: "PUT"
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler);

        fetch(`${this.webApiUrl}/unassigned-tickets/${completedTicketId}`, options).then(handler);
    }

}